import React from "react"
import { Navigate } from "react-router-dom"
import Spinners from "components/Shared/Spinners"
import { useParams } from "react-router-dom"
import { useAssignedBrands } from "hooks/useAssignedBrands"
import Orders from "./Orders"
import B2cOrders from "./B2cOrders"

const BrandOrdersPage = () => {
  const { brandId } = useParams()
  const { brands, loading, loaded } = useAssignedBrands()
  const brand = brands.find(entry => entry.brandId === brandId)

  if (loading || !loaded) {
    return <Spinners />
  }

  if (!brand) {
    return <Navigate to="/orders" replace />
  }

  if (brand.serviceProvider === "Salasa") {
    return <B2cOrders brandConfig={brand} />
  }

  return <Orders brandConfig={brand} />
}

export default BrandOrdersPage
